import { socialConfig } from '@/config/social-config'
import { GoogleOAuthProvider, useGoogleLogin } from '@react-oauth/google'
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'

export interface ILoginSocialCallBack {
  provider: 'facebook' | 'google'
  code?: string
  access_token?: string
}

interface Props {
  onLoginSocialCallback: (callback: ILoginSocialCallBack) => void
}

export default function SignInSocial({ onLoginSocialCallback }: Props) {
  return (
    <GoogleOAuthProvider clientId={socialConfig.google.clientId}>
      <div className="flex flex-col space-y-6">
        <div className="relative mt-4">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-200" />
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-4 text-gray-500 bg-white font-medium uppercase">
              Or Continue With
            </span>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <LoginWithGoogle onLoginSocialCallback={onLoginSocialCallback} />
          <LoginWithFacebook onLoginSocialCallback={onLoginSocialCallback} />
        </div>
      </div>
    </GoogleOAuthProvider>
  )
}

function LoginWithGoogle({ onLoginSocialCallback }: Props) {
  const loginWithGoogle = useGoogleLogin({
    onSuccess: (response) => {
      try {
        onLoginSocialCallback({
          provider: 'google',
          code: response.code!,
        })
      } catch (error) {
        console.error('Cannot login with google:', error)
      }
    },
    flow: 'auth-code',
  })
  return (
    <button
      onClick={loginWithGoogle}
      type="button"
      className="flex items-center justify-center w-full px-4 py-3 space-x-3 text-gray-700 bg-gray-200 hover:bg-gray-300 transition-colors duration-200"
    >
      <svg className="w-5 h-5" viewBox="0 0 24 24">
        <path
          d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
          fill="#4285F4"
        />
        <path
          d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
          fill="#34A853"
        />
        <path
          d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
          fill="#FBBC05"
        />
        <path
          d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
          fill="#EA4335"
        />
      </svg>
      <span className="font-medium">Google</span>
    </button>
  )
}

function LoginWithFacebook({ onLoginSocialCallback }: Props) {
  const responseFacebook = (response: any) => {
    const accessToken = response.accessToken
    if (!accessToken) return

    onLoginSocialCallback({
      provider: 'facebook',
      access_token: response.accessToken,
    })
  }

  return (
    <FacebookLogin
      appId={socialConfig.facebook.appId}
      callback={responseFacebook}
      fields="name,email,picture"
      scope="public_profile,email"
      render={(renderProps: any) => (
        <button
          onClick={renderProps.onClick}
          type="button"
          className="flex items-center justify-center w-full px-4 py-3 space-x-3 text-gray-700 bg-gray-200 hover:bg-gray-300 transition-colors duration-200"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#1877F2">
            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
          </svg>
          <span className="font-medium">Facebook</span>
        </button>
      )}
    />
  )
}
